import { render, staticRenderFns } from "./SiteAssetList.vue?vue&type=template&id=b0f5e51e&scoped=true&"
import script from "./SiteAssetList.vue?vue&type=script&lang=js&"
export * from "./SiteAssetList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f5e51e",
  null
  
)

export default component.exports